export default {
  computed: {
    computedBackRoute() {
      if (!this.$router.lastPath || this.$router.lastPath !== 'Opportunity show') {
        return this.backRoute;
      }
      return '.';
    },
  },
};
